import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import MoviesSection from "@/pages/home/components/MoviesSection";
import SeriesSection from "@/pages/home/components/SeriesSection";
import RankingSection from "@/pages/home/components/RankingSection";
import ClassicsSection from "@/pages/home/components/ClassicsSection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeaturedSection />
        <MoviesSection />
        <SeriesSection />
        <RankingSection />
        <ClassicsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}